import React, { useEffect, useMemo, useState } from "react";
import BootstrapSwitchButton from "bootstrap-switch-button-react";
import Form from "react-bootstrap/Form";
import Cookies from "js-cookie";
import { httpPostManageUserDetails } from "../../../../service/httpClient";
import { verifyAccessPermission } from "../../../../utils/rolePermissionAccess";
import "../../common.css";
import { Modal, Button } from "react-bootstrap";
import * as Const from "../../../../constants/Constants";

export const ActionCellRenderer = (props) => {
  const [checked, setChecked] = useState(props?.value);
  const toggleAction = () => {
    const data = props?.data || {};
    const tStatus = !checked;
    data.isActive = tStatus;
    data.updatedBy = Cookies.get("email");
    data.triggerWelcomeMail = false;
    data.auditMessage = "";
    props.node.setData(data);
    const { updateManagerUsersErrors } = props;
    updateManagerUsersErrors("refresh");
    httpPostManageUserDetails(data)
      .then((res) => {
        updateManagerUsersErrors("success");
        setChecked(tStatus);
      })
      .catch((err) => {
        setChecked(!tStatus);
        data.isActive = !tStatus;
        props.node.setData(data);
        updateManagerUsersErrors("failure");
      });
  };

  const handleClick = (val) => {
    setChecked(val);
  };
  const clsName = props?.data?.primaryUser
    ? "display-flex no-pointer-events"
    : "display-flex";
  return (
    <div className={clsName}>
      <span onClick={toggleAction}>
        <BootstrapSwitchButton
          checked={checked}
          onlabel="Active"
          offlabel="In Active"
          onstyle="danger"
          offstyle="secondary"
          size="sm"
          width={90}
        />
      </span>
    </div>
  );
};

export const UserCellRenderer = (props) => {
  const [userInfo, setUserInfo] = useState({
    userName: "",
    userEmail: "",
  });
  useEffect(() => {
    let user = props?.value.split(",");
    setUserInfo({
      userName: user[0],
      userEmail: user[1],
    });
  }, []);

  const { userName, userEmail } = userInfo;
  return (
    <div>
      <span className="dflex">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          fill="none"
          viewBox="0 0 24 24"
          stroke-width="1.5"
          stroke="currentColor"
          class="w-6 h-6 user-icon"
        >
          <path
            stroke-linecap="round"
            stroke-linejoin="round"
            d="M17.982 18.725A7.488 7.488 0 0012 15.75a7.488 7.488 0 00-5.982 2.975m11.963 0a9 9 0 10-11.963 0m11.963 0A8.966 8.966 0 0112 21a8.966 8.966 0 01-5.982-2.275M15 9.75a3 3 0 11-6 0 3 3 0 016 0z"
          />
        </svg>
        {userName}
      </span>
    </div>
  );
};

export const RoleCellRenderer = (props) => {
  const [isEdit, setIsEdit] = useState(true);
  const [selected, setSelected] = useState(props?.value);
  const field = props?.field;
  const data = props?.data;
  const isActive = data?.isActive;
  const options = props.options || [];
  const { updateManagerUsersErrors } = props;
  
  const handleChange = (e, type) => {
    updateManagerUsersErrors('refresh');
    const data = props?.data || {};
    const previousVmsRole = data?.vmsRole;
    const previousApplicationRole = data?.applicationRole;
    const selectedValue = e.target.value;
    if (field === "vms") {
      data.vmsRole = selectedValue;
    } else {
      data.applicationRole = selectedValue;
    }
    data.updatedBy = Cookies.get("email");
    data.triggerWelcomeMail = false;
    data.auditMessage = "";
    props.node.setData(data);
    httpPostManageUserDetails(data)
      .then((res) => {
        updateManagerUsersErrors('success');
        setSelected(selectedValue);
      })
      .catch((err) => {
        let resManageUserDetail = data || {};
        if (props.field === "vms") {
          resManageUserDetail.vmsRole = previousVmsRole;
          setSelected(previousVmsRole);
        } else {
          resManageUserDetail.applicationRole = previousApplicationRole;
          setSelected(previousApplicationRole);
        }
        props.node.setData(resManageUserDetail);
        updateManagerUsersErrors('failure');
      });
  };
  return (
    <div className="form-row mtop-5">
      <Form.Control
        as="select"
        className="role-container"
        disabled={
          isEdit ||
          !isActive ||
          (props.field === "vms" && props?.data?.primaryUser)
        }
        value={selected}
        onChange={(e) => handleChange(e)}
      >
        {options.map((option) => {
          let value = {};
          value = (
            <option
              value={option.name}
              selected={props.name === option.name ? true : ""}
            >
              {option.value}
            </option>
          );
          return value;
        })}
      </Form.Control>
      {isActive &&
        (!props?.data?.primaryUser ||
          (props.field !== "vms" && props?.data?.primaryUser)) && (
          <button className="edit-btn" onClick={() => setIsEdit(false)}>
            <svg
              className="editicon w-6 h-6"
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 24 24"
              strokeWidth={1.5}
              stroke="currentColor"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                d="M16.862 4.487l1.687-1.688a1.875 1.875 0 112.652 2.652L10.582 16.07a4.5 4.5 0 01-1.897 1.13L6 18l.8-2.685a4.5 4.5 0 011.13-1.897l8.932-8.931zm0 0L19.5 7.125M18 14v4.75A2.25 2.25 0 0115.75 21H5.25A2.25 2.25 0 013 18.75V8.25A2.25 2.25 0 015.25 6H10"
              />
            </svg>
          </button>
        )}
    </div>
  );
};

export const StatusRenderer = (props) => {
  return (
    <p className={props.value === "Created" ? "created" : "not-created"}>
      {props.value}
    </p>
  );
};

export const CompanyRenderer = (props) => {
  return <p className="company-info">{props.value}</p>;
};

export const SendEmailCellRenderer = (props) => {
  const [isEdit, setIsEdit] = useState(false);
  const [accessEnabled, setAccessEnabled] = useState(true);
  const [auditMessage, setAuditMessage] = useState("");
  const data = props?.data;
  const { updateManagerUsersErrors } = props;

  const handleAuditMessage = (e) => {
    setAuditMessage(e.target.value);
  }

  useEffect(() => {
    const accessToSendEmail = verifyAccessPermission("manageUsersSellerSendEmail");
    setAccessEnabled(accessToSendEmail);
  }, [])

  const handleSendEmail = () => {
    let requestObject = data;
    requestObject.updatedBy = Cookies.get("email");
    requestObject.triggerWelcomeMail = true;
    requestObject.auditMessage = auditMessage;
    httpPostManageUserDetails(requestObject)
      .then((res) => {
        updateManagerUsersErrors('email');
        setIsEdit(false);
      })
      .catch((err) => {
        updateManagerUsersErrors('failure');
      });
  }

  return (
    <>
      <Modal
        show={isEdit}
        onHide={() => {
          setIsEdit(false);
          setAuditMessage("")
        }}
        size="lg"
        className={props.cls} >
        <Modal.Header closeButton>
          <Modal.Title>{Const.SEND_EMAIL}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <textarea placeholder={Const.ENTER_REASON_PLACEHOLDER} className="audit-message-width" onKeyUp={(e) => setAuditMessage(e.target.value)}></textarea>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => {
          setIsEdit(false);
          setAuditMessage("")
        }}>
          {Const.NO}
          </Button>
          <Button disabled={auditMessage != "" ? false : true} variant={auditMessage != "" ?
            "no-pointer-events btn-danger" :
            "react-switch-bg"
          } onClick={handleSendEmail}>
              {Const.YES}
          </Button>
        </Modal.Footer>
      </Modal>
      <button disabled={accessEnabled ? false : true}
        className={
          accessEnabled ? "ag-custom-cell-sendemail-btn" :
            "ag-custom-cell-sendemail-disabled-btn"
        }
        onClick={() => setIsEdit(true)}>
        {Const.SEND_EMAIL}
      </button>
    </>
  )
}
